// NoticeViolation.model.ts

import { AppUser, IAppUser } from "./app-user.model";
import { FileMedia, IFileMedia } from "./file-media.model";
import { HouseFlat, IHouseFlat } from "./house-flat.model";

export interface INoticeViolation {
  noticeViolationId: string;
  neighborhoodId: string;
  houseFlatId: string;
  title: string;
  description: string;
  status: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  files: IFileMedia[];
  houseFlat: IHouseFlat | null;
  createdBy: IAppUser | null;
}

export class NoticeViolation {
  noticeViolationId: string;
  neighborhoodId: string;
  houseFlatId: string;
  title: string;
  description: string;
  status: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: Date;
  updatedAt: Date;
  files: FileMedia[];
  houseFlat: HouseFlat | null;
  createdBy: AppUser | null;

  constructor(data: INoticeViolation) {
    this.noticeViolationId = data.noticeViolationId;
    this.neighborhoodId = data.neighborhoodId;
    this.houseFlatId = data.houseFlatId;
    this.title = data.title;
    this.description = data.description;
    this.status = data.status;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.files = data.files
      ? data.files.map((file) => new FileMedia(file))
      : [];
    this.houseFlat = data.houseFlat
      ? new HouseFlat(data.houseFlat)
      : null;
    this.createdBy = data.createdBy
      ? new AppUser(data.createdBy)
      : null;
  }

  /** Calle + número de la casa. Si el API no trajo la casa, cae al id. */
  get houseLabel(): string {

    if (!this.houseFlat) {
      return this.houseFlatId;
    }

    const street = this.houseFlat.streetBuilding?.name;

    return street
      ? `${street} ${this.houseFlat.number}`
      : this.houseFlat.number;
  }

  get images(): FileMedia[] {
    return this.files.filter((file) => file.fileType === 'image');
  }

  get pdfs(): FileMedia[] {
    return this.files.filter((file) => file.fileType === 'pdf');
  }
}
